import DataModel from '../common/model/DataModel';
import DateTimeUtils from '../common/utils/DateTimeUtils';

import { DateViewMode } from '../common/value-types/DateViewMode';

import PreferenceManager from '../application/PreferenceManager';

export default class ScheduleCommandDataModel extends DataModel {
  constructor(preferenceGroupName) {
    super();

    this.preferenceGroupName = preferenceGroupName;

    this.createEvent('fullRefresh');
    this.createEvent('backgroundRefresh');
    this.createEvent('showManageColumnPreferences');
    this.createEvent('updateSchedules');
    this.createEvent('gridFiltersChanged');
    this.createEvent('dateRollingOver');
    this.createEvent('enactEditMode');
    this.createEvent('submitChanges');
    this.createEvent('revertChanges');
    this.createEvent('exportToExcel');
    this.createEvent('resubmitValues');
    this.createEvent('recalculateValues');
    
    this.isEditingEnabled = false;
    this.isModified = false;
    this.hasValidationErrors = false;
    this.isOperationInProgress = false;
    this.showEditMode = false;
    this.canUserManageColumnPreferences = false;
    this.currentContracts = [];
    this.resubmitContracts = [];
    this.recalculateContracts = [];

    this.currentMonth = PreferenceManager.retrieveDate(
      this.preferenceGroupName,
      PreferenceManager.CurrentMonth,
      DateTimeUtils.getThisMonth()
    );

    this.useSelectionEditMode = PreferenceManager.retrieveValue(
      this.preferenceGroupName,
      PreferenceManager.UseSelectionEditMode,
      true
    );

    this.showPastDays = PreferenceManager.retrieveValue(
      this.preferenceGroupName,
      PreferenceManager.ShowPastDays,
      false
    );

    this.dateViewMode = PreferenceManager.retrieveValue(
      this.preferenceGroupName,
      PreferenceManager.DateViewMode,
      DateViewMode.fullMonth
    );
  }

  onPropertyUpdated(propertyName, oldValue, newValue) {
    switch (propertyName) {
      case 'currentMonth':
        PreferenceManager.updateDate(
          this.preferenceGroupName,
          PreferenceManager.CurrentMonth,
          newValue
        );
        break;
      case 'useSelectionEditMode':
        PreferenceManager.updateValue(
          this.preferenceGroupName,
          PreferenceManager.UseSelectionEditMode,
          newValue
        );
        break;
      case 'showPastDays':
        PreferenceManager.updateValue(
          this.preferenceGroupName,
          PreferenceManager.ShowPastDays,
          newValue
        );
        break;
      case 'dateViewMode':
        PreferenceManager.updateValue(
          this.preferenceGroupName,
          PreferenceManager.DateViewMode,
          newValue
        );
        break;
      default:
        break;
    }
  }
}